import {AxiosRequestConfig} from 'axios';
import request from '../../axios';

const getStoreRedesignView = async (guid?: string) => {
  const {data}: {data: IStoreDetail} = await request.get(
    'api/v2/store/store-redesign-view',
    {
      params: {guid},
    } as AxiosRequestConfig,
  );
  return data;
};

export default getStoreRedesignView;
